import examApi from '@/api/exam.api'

import { GroupStudentProblem } from '@/dto'

class ExamGroupScoringController {
  adapter = {
    groupStudentProblems: {
      from: (data: res.GroupStudentExamResult) => {
        return new GroupStudentProblem(data)
      },
    },
    scoringSummaryToGroupStudentProblem: {
      from: (data: res.ScoringSummary['studentExamScoringSummary'][number]) => {
        return new GroupStudentProblem({
          id: data.studentExamId,
          studentId: data.studentId,
          studentName: data.studentName,
          scoringList: data.scoringList.map((scoring) => ({
            examProblemId: scoring.examProblemId,
            result: scoring.result,
            score: scoring.score,
          })),
        })
      },
    },
    studentScoring: {
      from: (data: res.ExamProblemScore) => {
        return {
          id: data.id,
          problemId: data.problemId,
          score: data.score,
          problem: {
            type: data.problem.type,
            answer: data.problem.answer,
            problemImageUrl: data.problem.problemImageUrl,
            answerImageUrl: data.problem.answerImageUrl,
            solutionImageUrl: data.problem.solutionImageUrl,
            video: data.problem.video,
          },
        }
      },
    },
  }

  fetchGroupStudentProblems = async (examId) => {
    const {
      data: { data },
    } = await examApi.getExamScoring(examId)

    const parseData = data.map(this.adapter.groupStudentProblems.from)
    return parseData.sort((a, b) =>
      a.studentName > b.studentName ? 1 : a.studentName < b.studentName ? -1 : 0,
    )
  }

  fetchStudentScoring = async (studentExamId) => {
    const {
      data: { data },
    } = await examApi.getStudentExamProblems(studentExamId)

    const parseData = data.map(this.adapter.studentScoring.from)
    return parseData
  }

  patchStudentScoring = async (studentExamId, params) => {
    const { data } = await examApi.patchStudentExanScoring(studentExamId, params)
    return data
  }

  fetchScoringSummary = async (
    examId: res.AssignedExam['id'],
    studentExamIds: res.AssignedStudent['id'][],
  ) => {
    const { data } = await examApi.getStudentExamScoringSummary(examId, studentExamIds)
    return data
  }

  fetchScoringSummaryToGroupStudentProblem = async (
    examId: res.AssignedExam['id'],
    studentExamIds: res.AssignedStudent['id'][],
  ) => {
    const {
      data: { studentExamScoringSummary, problems },
    } = await examApi.getStudentExamScoringSummary(examId, studentExamIds)

    const parseData = studentExamScoringSummary.map(
      this.adapter.scoringSummaryToGroupStudentProblem.from,
    )

    return {
      problems,
      scoringSummaryToGroupStudentProblem: parseData.sort((a, b) =>
        a.studentName > b.studentName ? 1 : a.studentName < b.studentName ? -1 : 0,
      ),
    }
  }
}

export const examGroupScoringController = new ExamGroupScoringController()
